"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecurrentCGPExecutor = void 0;
const CGPProgram_1 = require("./CGPProgram");
class RecurrentCGPExecutor {
    constructor(program, config, defaultState, useForwardPass = false) {
        this.useForwardPass = useForwardPass;
        this.program = program;
        this.config = config;
        //this.activeNodes = new Set();
        this.defaultState = defaultState;
        /*
        for (const outputNodeIdx of this.program.outputs) {
            this.addActiveNodes(outputNodeIdx);
        }
        */
        this.currentState = Array.from({ length: (this.config.numInputs + this.program.middleNodes.length) }, (_, i) => defaultState);
    }
    getEffectiveIdx(nodeIdx) {
        const totalIdx = this.config.numInputs + this.program.middleNodes.length;
        const effectiveIdx = nodeIdx % totalIdx;
        return (0, CGPProgram_1.asNodeIndex)(effectiveIdx);
    }
    getNodeValue(nodeIdx, inputs) {
        const effectiveIdx = this.getEffectiveIdx(nodeIdx);
        if (effectiveIdx < inputs.length) {
            return inputs[effectiveIdx];
        }
        // It's a middle node, so apply the operation:
        const middleNode = this.program.middleNodes[effectiveIdx - this.config.numInputs];
        const inputIndexes = middleNode.inputIndexes.map((i) => this.getEffectiveIdx(i));
        if (this.useForwardPass) {
            const inputValues = inputIndexes.map((idx) => {
                return idx < effectiveIdx ? this.getNodeValue(idx, inputs) : this.currentState[idx];
            });
            const effectiveOpIdx = middleNode.operator % this.config.operators.length;
            return this.config.operators[effectiveOpIdx](inputValues);
        }
        const inputValues = inputIndexes.map((idx) => this.currentState[idx]);
        const effectiveOpIdx = middleNode.operator % this.config.operators.length;
        return this.config.operators[effectiveOpIdx](inputValues);
    }
    execute(inputs) {
        // 1: Feed our input into our current state:
        inputs.forEach((input, idx) => {
            this.currentState[idx] = input;
        });
        // 1: Set up our new state:
        const newState = Array.from({ length: (this.config.numInputs + this.program.middleNodes.length) }, (_, i) => this.getNodeValue((0, CGPProgram_1.asNodeIndex)(i), inputs)
        //this.defaultState
        );
        // 2: Replace our old state:
        this.currentState = newState;
        // Get our outputs:
        return this.program.outputs.map((outIdx) => {
            return this.currentState[this.getEffectiveIdx(outIdx)];
        });
    }
}
exports.RecurrentCGPExecutor = RecurrentCGPExecutor;
